import apiClient from '@shared/services/apiClient';
import type { CreateContactRequest, UpdateContactRequest } from '../types/contact';

export const contactApi = {
  createContact: async (clinicId: number, request: CreateContactRequest): Promise<{ contactId: number }> => {
    const response = await apiClient.post(`/clinics/${clinicId}/contacts`, request);
    return response.data;
  },

  updateContact: async (contactId: number, request: UpdateContactRequest): Promise<void> => {
    await apiClient.put(`/contacts/${contactId}`, request);
  },

  deleteContact: async (contactId: number): Promise<void> => {
    await apiClient.delete(`/contacts/${contactId}`);
  },
};
